import { RouteConfig, RouteId, RouteTextOverrideArgs, GetBreadcrumbsResponse } from 'types';
import GET_SUPPORT_CATEGORY_CACHE_REDIRECT from 'graph/support/support-category-cache-redirect-query';
import HelpIcon from '@material-ui/icons/Help';
import SupportCategory from '../SupportCategory';

const routePrefix = '/support';
const title = 'Help & Support';

const routes: RouteConfig[] = [
  {
    Component: SupportCategory,
    getTitle: () => title,
    path: `${routePrefix}/:categoryId`,
    getBreadcrumbs: ({ match, client }: RouteTextOverrideArgs): GetBreadcrumbsResponse => {
      const categoryId = match?.params?.categoryId;
      let result;

      try {
        result = client.readQuery({
          query: GET_SUPPORT_CATEGORY_CACHE_REDIRECT,
          variables: { id: categoryId }
        });
      } catch (err) {
        // do nothing
      }

      return [
        {
          name: title,
          path: '/support',
          Icon: HelpIcon
        },
        {
          name: result?.supportCategoryDetail?.title || title,
          path: `${routePrefix}/${categoryId}`
        }
      ];
    },
    id: RouteId.SUPPORT_CATEGORY,
    privileges: []
  }
];

const getRoutes = (): RouteConfig[] => {
  return routes;
};

export default getRoutes;
